import Firebase from '../../Config/firebase';

export const uploadImage = async (image, bucket) => {
    const storageRef = Firebase.storage().ref(bucket);
    const fileRef = storageRef.child(Math.random() + image.name);
    await fileRef.put(image);
    return await fileRef.getDownloadURL();
}